import { render, staticRenderFns } from "./PotensiMain.vue?vue&type=template&id=4737c4fa&scoped=true"
import script from "./PotensiMain.vue?vue&type=script&lang=js"
export * from "./PotensiMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4737c4fa",
  null
  
)

export default component.exports